/*
 * The Lienzo editor's conversation column (the mockup's `.conv`): a 40px head, the thread that
 * scrolls (`.thread`, a log) and the composer at the foot (`.composer`).
 */
.conversation {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-block-size: 0;
}

.head {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--space-2);
  block-size: 40px;
  padding: 0 var(--space-4);
  border-bottom: 1px solid var(--border);
}

.title {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.spacer {
  flex: 1;
}

.thread {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-4);
  min-block-size: 0;
  padding: var(--space-4);
  overflow-y: auto;
}

.foot {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4) var(--space-4);
  border-top: 1px solid var(--border);
}

.notice {
  margin: 0;
  max-width: 42rem;
  color: var(--text-muted);
}

/* The thread is reachable by keyboard (it scrolls): the ring sits inside, where the column cannot clip it. */
.thread:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -2px;
}

.skip {
  display: flex;
  justify-content: flex-start;
}
